import { addressTokens, createTokens } from '@sail/engine';
import { tokens } from '@sail/ui';
import { helmTokens } from '../../theme';
export const copyTokens = (()=>{
    const copyTokens = createTokens('helmCopy', {
        columnPaddingLeft: helmTokens.layout.columnPadding.normal,
        columnPaddingRight: helmTokens.layout.columnPadding.medium,
        paragraphGap: tokens.space[250],
        rowGap: helmTokens.layout.rowGap.medium
    });
    addressTokens(copyTokens);
    return copyTokens;
})();

//# sourceMappingURL=tokens.js.map